import { SearchIcon } from '@chakra-ui/icons';
import {
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';

import type { Item } from '@revelio/iso-utility';

import { CompanySearchTree } from '../../../../shared/components/company-search-tree/company-search-tree';
import type { CompanyResultItem } from '../../../../shared/types/company-result-item';
import { remapCompany } from './company-mapping.respository';

const sortByEmployeeCount = (a: Item, b: Item) =>
  Number(b.raw_emp_count ?? 0) - Number(a.raw_emp_count ?? 0);

export const RemapCompany = ({
  rcid,
  missingCompaniesIndexToMap,
}: {
  rcid?: number;
  missingCompaniesIndexToMap?: number;
}) => {
  const { onOpen, onClose: onCloseMappingSearch, isOpen } = useDisclosure();
  const popoverRef = useRef(null);
  useOutsideClick({
    ref: popoverRef,
    handler: onCloseMappingSearch,
  });

  const [selections, setSelections] = useState<
    Record<string, CompanyResultItem>
  >({});

  useEffect(() => {
    const selected = Object.values(selections)[0];
    if (!selected) return;

    remapCompany({
      rcid,
      newMapping: {
        primary_name: selected.primary_name,
        company_id: selected.company_id,
        rcid: selected.rcid,
        raw_emp_count: selected.raw_emp_count,
        has_subsidiaries: selected.has_subsidiaries,
        primary_identifiers: {
          primary_name: selected.primary_name,
          primary_website: '',
          primary_ticker: '',
          primary_linkedin_url: '',
          country: '',
          state: '',
          city: '',
        },
      },
      missingCompaniesIndexToMap,
    });
    onCloseMappingSearch();
    setSelections({});
  }, [selections, rcid, missingCompaniesIndexToMap, onCloseMappingSearch]);

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onCloseMappingSearch}>
      <PopoverTrigger>
        <IconButton
          aria-label="Search Company Universe"
          icon={<SearchIcon />}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent ref={popoverRef}>
          <PopoverArrow />
          <PopoverBody>
            <CompanySearchTree
              singleSelect
              autoFocus
              placeholderListNodes={[]}
              selections={selections}
              setSelections={setSelections}
              sortFn={sortByEmployeeCount}
              treeHeight={200}
            />
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
